<template>
  <v-row dense class="LKPublicationsStorageHeader">
    <v-col>
      <div
        class="LKPublicationsStorageHeader__name"
        v-text="data.name"
      />

      <div class="LKPublicationsStorageHeader__desc">
        Файлы доступны с
        <b>{{ start_at }}</b>
        <template v-if="end_at">
          по <b>{{ end_at }}</b>
        </template>
      </div>
    </v-col>

    <v-col v-if="showReportBtn" cols="auto">
      <button
        class="LKPublicationsStorageHeader__button"
        @click="onOpenReportModal"
      >
        <b>Отчёт</b>
      </button>
    </v-col>
    <v-col v-if="false" cols="auto">
      <button
        :disabled="data.disabled || noFiles || isLoading"
        class="LKPublicationsStorageHeader__button"
        @click="onDownloadArchiveClick"
      >
        <b>Скачать всё</b> .zip
      </button>
    </v-col>
  </v-row>
</template>

<script>
import { downloadLink } from '@/helpers/downloadBlob'
import { uiDateFormatter } from '@/helpers/dateFormatter'
import { LKPublicationsFormdataReportModal } from '@/views/LKPublications/formdata/utils'
import { rootMapper } from '@/store/modules/root'


const DATE_FORMAT = 'DD MMM YYYY / HH:mm'

const getDate = (date) => uiDateFormatter(date, DATE_FORMAT)

const createFileUrl = (publicationId, storageId) => `/lk/api/v2/publications/${publicationId}/storages/${storageId}/files_dump`

export default {
  name: 'LKPublicationsStorageHeader',
  props: {
    publicationId: {
      type: Number,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    ...rootMapper.mapGetters(['profile']),

    start_at() {
      return getDate(this.data.start_at)
    },
    end_at() {
      return getDate(this.data.end_at)
    },
    href() {
      return createFileUrl(
        this.publicationId,
        this.data.id,
      )
    },
    ext() {
      let ext
      if (this.data.name) {
        const arr = this.data.name.split('.')
        ext = arr.length > 1 ? arr[arr.length - 1] : null
      }
      return ext
    },
    filename() {
      const { ext } = this
      const filename = this.data?.name || 'Документы'
      return ext ? `${filename}.${ext}` : filename
    },
    noFiles() {
      return !this.data.files || this.data.files.every(({ disabled }) => !!disabled)
    },
    showReportBtn() {
      return this.data.access_report
    },
  },
  methods: {
    toggleLoading() {
      this.isLoading = !this.isLoading
      return this.toggleLoading
    },
    async onDownloadArchiveClick() {
      this.isLoading = true

      try {
        await downloadLink(this.href, this.filename)
        this.isLoading = false
        this.$emit('downloaded', this.toggleLoading)
      } catch (e) {
        this.$notice.errors(e)
        this.isLoading = false
      }
    },
    async onOpenReportModal() {
      const propsData = {
        reportCode: 'storage',
        params: { storage_id: this.data.id },
        title: this.data.name,
      }
      const modal = await LKPublicationsFormdataReportModal(this, propsData)
      await modal.open()
    },
  },
}
</script>

<style lang="scss">
.LKPublicationsStorageHeader {
  b {
    font-weight: 500;
    color: $webflow-color-black;
  }

  &__name {
    font-size: 18px;
    font-weight: 600;
  }

  &__desc {
    font-size: 12px;
    color: $webflow-color-blue-dark;
  }

  &__button {
    display: flex;
    align-items: center;
    height: 32px;
    padding: 0 12px;
    font-size: 12px;
    color: $webflow-color-blue-dark-3;
    cursor: pointer;
    border: 1px solid $webflow-color-black;
    border-radius: 2px;
    transition: background-color 0.25;

    &:hover {
      background-color: rgba($webflow-color-blue-dark, 0.1);
    }

    &[disabled] {
      pointer-events: none;
      opacity: 0.25;
    }
  }
}
</style>
